import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionAutomationAnywhereState } from 'app/rpa-bots/core/IRpaBots';

const automationAnywhereSelector = (state: IAppState) => state.rpaState.automationAnywhere;

export const getAutomationConnList = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.connectors
);

export const getIsLoadingList = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingList
);

export const getIsLoadingDetail = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingDetail
);

export const getIsLoadingDevices = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingDevices
);

export const getIsLoadingPoolDevices = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingPoolDevices
);

export const getIsLoadingUsers = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingUsers
);

export const getIsLoadingBots = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.isLoadingBots
);

export const getAutomationCurrentConnector = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentConnector
);

export const getAutomationCurrentConnectorBots = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentConnectorBots
);

export const getAutomationCurrentConnectorDevices = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentConnectorDevices
);

export const getAutomationCurrentRpaPoolDevices = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentRpaPoolDevices
);

export const getVersionCurrentAutomationAnywhere = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentVersionRpa
);


export const getAutomationCurrentRpaUsers = createSelector(
    automationAnywhereSelector,
    (state: IRpaConnectionAutomationAnywhereState) => state.currentRpaUsers
);
